import { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { IonRouterOutlet } from '@ionic/react';
import { AllieMainLayoutProps } from './MainLayout';

export const AllieMainLayoutDesktop: FC<AllieMainLayoutProps> = ({ menu: Menu, page: Page }) => (
  <>
    {Menu && <Menu />}
    <div style={{ height: '100%', width: '100%', position: 'relative' }}>
      <Page />
    </div>
  </>
);
